import "./Contact.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faLocationDot,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import emailjs from "@emailjs/browser";
import { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";

const Contact = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setFocus,
  } = useForm();
  const [userData, setUserData] = useState();
  const [contactThanks, setContactThanks] = useState(false);
  const [loading, setLoading] = useState(false);
  const formData = useRef();
  const onSubmit = (data) => {
    setLoading(true);
    emailjs
      .sendForm(
        "service_xmruesz",
        "template_cucogxi",
        formData.current,
        "rSaq5HudHGqwQpK7a"
      )
      .then(
        (result) => {
          setLoading(false);
          setContactThanks(true);
        },
        (error) => {
          console.log(error.text);
        }
      );
    const temp = JSON.stringify(data);
    console.log(temp.user_name);
  };
  return (
    <>
      <div className="contact_root" id="contact">
        <h2>
          We are Here for You
          <hr className="contact_line"></hr>
        </h2>

        <div className="contact_wrapper">
          <div className="contact_inner_wrapper">
            <div className="contact_left">
              <div className="contact_info">
                <div>
                  <FontAwesomeIcon icon={faLocationDot} />
                  <h4 className="title">Our location</h4>
                  <p className="my-lg-3 mt-2">
                    Pradeep Automotive Ltd. Phoenix Bldg. B,Shop No. 8, Benham
                    Hall Lane. S.V.P Road. Mumbai(400004)
                  </p>
                  <div className="google-maps">
                    <iframe
                      title="gmaps"
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3773.4080326274407!2d72.81441832288367!3d18.957578946074126!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7ce119e5233b7%3A0x439573ca88d055a8!2sPradeep%20Automotive%20Private%20Ltd!5e0!3m2!1sen!2sin!4v1675662907284!5m2!1sen!2sin"
                      width="300"
                      height="200"
                      style={{
                        border: 0,
                        borderRadius: "5px",
                      }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>

                  <FontAwesomeIcon icon={faEnvelope} />
                  <h4 className="title mb-4">Quick Contact</h4>
                  <p className="my-lg-3 mt-2">
                    Email : info@pradeepautomotive.com
                  </p>
                  <p style={{ marginBottom: 0 }}>Phone : 022 23808403</p>
                </div>
              </div>
            </div>
            <div className="contact_right">
              {loading ? (
                <span className="loader"></span>
              ) : (
                <>
                  {contactThanks ? (
                    <div className="thankyou">
                      <svg
                        class="checkmark"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 52 52"
                      >
                        <circle
                          class="checkmark__circle"
                          cx="26"
                          cy="26"
                          r="25"
                          fill="none"
                        />
                        <path
                          class="checkmark__check"
                          fill="none"
                          d="M14.1 27.2l7.1 7.2 16.7-16.8"
                        />
                      </svg>
                      <p>Thank you for getting in touch!</p>
                      <p>
                        We appreciate you contacting us, we will get back in
                        touch with you soon! Have a great day!
                      </p>
                    </div>
                  ) : (
                    <form
                      ref={formData}
                      className="contact_form"
                      onSubmit={handleSubmit(onSubmit)}
                    >
                      <h3>Request a quote</h3>
                      <div className="contact_right_wrapper">
                        <div className="input_wrapper">
                          <input
                            type="text"
                            id="user_name"
                            placeholder="Name"
                            style={{
                              border: `1px solid ${
                                errors.user_name ? "red" : "transparent"
                              }`,
                            }}
                            {...register("user_name", {
                              required: "Name is required",
                            })}
                          />
                          <span className="error">
                            {errors.user_name?.message}
                          </span>
                        </div>
                        <div className="input_wrapper">
                          <input
                            type="email"
                            id="user_email"
                            placeholder="Email"
                            style={{
                              border: `1px solid ${
                                errors.user_email ? "red" : "transparent"
                              }`,
                            }}
                            {...register("user_email", {
                              required: "Email is required",
                              pattern: {
                                value: /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/,
                                message: "Please enter a valid email",
                              },
                            })}
                          />
                          <span className="error">
                            {errors.user_email?.message}
                          </span>
                        </div>
                        <div className="input_wrapper">
                          <input
                            type="number"
                            id="phone"
                            placeholder="Phone"
                            style={{
                              border: `1px solid ${
                                errors.phone ? "red" : "transparent"
                              }`,
                            }}
                            {...register("phone", {
                              required: "Phone is required",
                            })}
                          />
                          <span className="error">{errors.phone?.message}</span>
                        </div>
                        <div className="input_wrapper">
                          <input
                            type="text"
                            id="company_name"
                            placeholder="Company Name"
                            style={{
                              border: `1px solid ${
                                errors.company_name ? "red" : "transparent"
                              }`,
                            }}
                            {...register("company_name", {
                              required: "Company name is required",
                            })}
                          />

                          <span className="error">
                            {errors.company_name?.message}
                          </span>
                        </div>
                        <textarea
                          id="message"
                          placeholder="Message"
                          style={{
                            border: `1px solid ${
                              errors.message ? "red" : "transparent"
                            }`,
                          }}
                          {...register("message", {
                            required: "Message is required",
                          })}
                        />
                        <span className="error">{errors.message?.message}</span>
                        <button type="submit">
                          Submit request
                          <FontAwesomeIcon
                            icon={faArrowRight}
                            className="nav_arrowRight"
                          />
                        </button>
                      </div>
                    </form>
                  )}
                </>
              )}
            </div>
          </div>
          <hr className="contact_wrapper_line"></hr>
        </div>
      </div>
    </>
  );
};
export default Contact;
